import 'magnific-popup';

/**
 * Popup initializaition
 */
$('.js-popup').magnificPopup({
	type: 'iframe',
	mainClass: 'mfp-fade',
	removalDelay: 160,
	preloader: false,
	fixedContentPos: false
});
